<app-breadcrumb [home]="home" [items]="breadcrumbs" />

@if (!overview() || errorMessage() || isPartner() === false) {
  <!-- Com o link carregado, o título vai para dentro do bloco navy (opção A, card 3765). -->
  <header class="page-header">
    <h2>Indique e ganhe</h2>
    <p class="referral__subtitle">
      Compartilhe seu link com quem pode virar parceiro da Legatus e acompanhe quem chegou por ele.
    </p>
  </header>
}

@if (isPartner() === false) {
  <!-- Usuário interno chegou por URL direta: o link de indicação é do usuário do parceiro. -->
  <div class="referral__note" role="note">
    <i class="pi pi-info-circle" aria-hidden="true"></i>
    <div>
      <strong>Esta tela é do parceiro.</strong>
      <p>
        O link de indicação pertence a cada usuário de parceiro. Para ver quem indicou um parceiro e
        quem ele indicou, abra o parceiro em Negociação › Comercial › Parceiros.
      </p>
    </div>
  </div>
} @else if (isPartner()) {
  @if (loading()) {
    <div class="referral__loading" role="status" aria-label="Carregando">
      <app-cog-loading-spinner [size]="64" />
    </div>
  } @else if (errorMessage()) {
    <div class="referral__error" role="alert">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <div>
        <strong>O seu link de indicação não carregou.</strong>
        <p>{{ errorMessage() }}</p>
      </div>
      <app-button
        label="Tentar de novo"
        icon="pi pi-refresh"
        theme="white"
        [type]="'button'"
        (sendButtonClick)="load()" />
    </div>
  } @else if (overview()) {
    <!-- Opção A da rodada 2 do protótipo, escolhida em 28/10/2026 (card 3765; acervo,
         indique-e-ganhe-opcoes-de-visual-card-3461#v2-a): bloco navy com a regra dos 10%, o link e o
         compartilhar; os números em cartões com ícone; a lista na largura toda. -->
    <section class="referral-hero" aria-labelledby="referral-hero-title">
      <div class="referral-hero__content">
        <span class="referral-hero__eyebrow">
          <i class="pi pi-gift" aria-hidden="true"></i>
          Indique e ganhe
        </span>
        <h2 id="referral-hero-title" class="referral-hero__title">
          Indique parceiros e ganhe
          <span class="referral-hero__accent">10% da receita</span>
          do primeiro deal
        </h2>
        <p class="referral-hero__rule">
          A cada parceiro que você indicar, você recebe 10% da receita da Legatus no primeiro deal
          que ele fechar.
        </p>

        <div class="referral-hero__link-box">
          <i class="pi pi-link referral-hero__link-icon" aria-hidden="true"></i>
          <span class="referral-hero__link" aria-label="Seu link de indicação">{{
            referralLink()
          }}</span>
          <div class="referral-hero__copy">
            <app-button
              [label]="copied() ? 'Copiado ✓' : 'Copiar link'"
              [icon]="copied() ? '' : 'pi pi-copy'"
              theme="white"
              size="small"
              [noMargin]="true"
              [type]="'button'"
              (sendButtonClick)="copyLink()" />
          </div>
        </div>

        <div class="referral-hero__share" role="group" aria-label="Compartilhar o link">
          <span>Compartilhar:</span>
          <app-button
            icon="pi pi-whatsapp"
            theme="white"
            size="small"
            [rounded]="true"
            [noMargin]="true"
            ariaLabel="Compartilhar no WhatsApp"
            title="WhatsApp"
            [type]="'button'"
            (sendButtonClick)="share('whatsapp')" />
          <app-button
            icon="pi pi-linkedin"
            theme="white"
            size="small"
            [rounded]="true"
            [noMargin]="true"
            ariaLabel="Compartilhar no LinkedIn"
            title="LinkedIn"
            [type]="'button'"
            (sendButtonClick)="share('linkedin')" />
          <app-button
            icon="pi pi-envelope"
            theme="white"
            size="small"
            [rounded]="true"
            [noMargin]="true"
            ariaLabel="Compartilhar por e-mail"
            title="E-mail"
            [type]="'button'"
            (sendButtonClick)="share('email')" />
        </div>
      </div>

      <div class="referral-hero__badge" aria-hidden="true">
        <strong>10%</strong>
        <span>da receita do<br />primeiro deal</span>
      </div>
    </section>

    <section class="referral-kpis" aria-label="Resumo das indicações">
      @for (kpi of kpis(); track kpi.label) {
        <div class="referral-kpi">
          <span [class]="'referral-kpi__icon referral-kpi__icon--' + kpi.tone" aria-hidden="true">
            <i [class]="kpi.icon"></i>
          </span>
          <div>
            <span class="referral-kpi__label">{{ kpi.label }}</span>
            <strong class="referral-kpi__value" [class.is-highlight]="kpi.tone === 'brand'">{{
              kpi.value
            }}</strong>
          </div>
        </div>
      }
    </section>
    <p class="referral__hint">
      Quem se cadastrar como parceiro da Legatus pelo seu link fica vinculado a você, e a indicação
      aparece abaixo.
    </p>

    <section class="referral-card">
      <h3 class="referral-card__title">
        <i class="pi pi-users" aria-hidden="true"></i>
        {{ isMaster() ? 'Indicações da sua equipe' : 'Suas indicações' }}
        @if (referrals().length) {
          <span class="referral-card__count">{{ referrals().length }}</span>
        }
      </h3>

      @if (referrals().length) {
        <app-table
          [items]="referrals()"
          [columnDefinitions]="columnDefinitions()"
          [dataKey]="'partnerId'"
          [hasPagination]="referrals().length > 15"
          [inMemoryPagination]="true"
          [rows]="15"
          [rowsPerPageOptions]="[15, 30, 50, 100]">
          <ng-template appNamedTemplate="partnerName" let-item>
            <div class="referral__who">
              <strong>{{ item.partnerName }}</strong>
              <span>{{ detail(item) }}</span>
            </div>
          </ng-template>

          <ng-template appNamedTemplate="referredByUserName" let-item>
            {{ item.referredByUserName || '—' }}
          </ng-template>

          <ng-template appNamedTemplate="channel" let-item>
            {{ channelLabel(item.channel) }}
          </ng-template>

          <ng-template appNamedTemplate="referredAt" let-item>
            {{ item.referredAt | vaultDateTime }}
          </ng-template>

          <ng-template appNamedTemplate="status" let-item>
            <span
              class="referral-tag"
              [class.referral-tag--info]="item.status === 'SignedUp'"
              [class.referral-tag--success]="item.status === 'DealGenerated'">
              {{ statusLabel(item.status) }}
            </span>
          </ng-template>
        </app-table>
      } @else {
        <div class="referral__empty">
          <span class="referral__empty-icon" aria-hidden="true"><i class="pi pi-send"></i></span>
          <strong>
            {{
              isMaster()
                ? 'Sua equipe ainda não indicou nenhum parceiro'
                : 'Você ainda não indicou nenhum parceiro'
            }}
          </strong>
          <p>
            {{
              isMaster()
                ? 'Compartilhe o seu link acima. Quem se cadastrar como parceiro pelos links da equipe aparece aqui.'
                : 'Compartilhe o link acima. Quem se cadastrar como parceiro por ele aparece aqui.'
            }}
          </p>
        </div>
      }
    </section>
  }
}
